import appendPxIfNeeded from './append-px-if-needed';
import mapObject from './map-object';
export default function appendImportantToEachValue(style) {
  return mapObject(style, function (result, key) {
    return appendPxIfNeeded(key, style[key]) + ' !important';
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/radium/es/append-important-to-each-value.js
// module id = 1276
// module chunks = 66